import React from "react";

import { handlePrecision } from "components/dashboard/product-template-table/utils/utils";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { IDoubleProps } from "../../../utils/cellInterfaces";

export default function Double({
  value,
  unit,
  selectionValues,
  precision,
  formatNumber,
  changeHandler,
  isInEditMode,
}: IDoubleProps) {
  const onSelect = (e: DropdownChangeEvent) => {
    changeHandler(parseFloat(e.value));
  };

  const handleChangeValue = (val: number | null) => {
    if (val !== null && val !== undefined) {
        changeHandler(val);
    } else {
      changeHandler("");
    }
  };

  if (isInEditMode) {
    if (selectionValues && selectionValues.length > 0) {
      return (
        <Dropdown
          value={value}
          style={{ width: "100%", textAlign: "left" }}
          options={selectionValues}
          placeholder={String(value)}
          onChange={e => onSelect(e)}
          required
        />
      );
    }
    return (
      <InputNumber
        value={value}
        onChange={e => handleChangeValue(e.value)}
        className="w-full"
        locale="lt"
        onFocus={e => e.target.select()}
        maxFractionDigits={precision}
        minFractionDigits={precision}
        suffix={unit && unit.replaceAll(" ", "") ? ` ${unit}` : ""}
      />
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{ whiteSpace: "nowrap", backgroundColor: "inherit", color: "inherit", border: "none" }}
    >
      {`${handlePrecision(value, precision, true, formatNumber)} ${unit}`}
    </div>
  );
}
